import { z } from 'zod'

import { zodErrorParser } from '@/utils/zod'
import { BaseEntitySchema } from './Common'

const DeviceTokenResponseSchema = BaseEntitySchema.extend({
  id: z.uuid(),
  token: z.string(),
  deviceKey: z.string(),
  deviceName: z.string(),
  deviceTimezone: z.string(),
  user: z.object({
    id: z.string(),
  }),
}).strict()

export type DeviceTokenResponse = z.infer<typeof DeviceTokenResponseSchema>

export const zodDeviceTokenResponseValidator = (
  data: DeviceTokenResponse[]
) => zodErrorParser(
  'DeviceTokenResponse',
  DeviceTokenResponseSchema,
  data,
)
